import { useEffect, useState } from 'react';
import { api } from '../api';
import { Page } from '../ui';

const CAT_LABEL: Record<string, string> = {
  step: 'Steps do pipeline',
  flow: 'Fluxos (sequência + ênfases)',
  template: 'Outros fluxos (prompts)',
};
const CATS = ['step', 'flow', 'template'];

interface MdItem {
  category: string;
  name: string;
  updatedAt: string;
}

export function AdminPipelineMd() {
  const [items, setItems] = useState<MdItem[]>([]);
  const [sel, setSel] = useState<{ category: string; name: string } | null>(null);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api.listPipelineMd().then((r) => setItems(r.items)).catch(() => setMsg('Falha ao carregar lista'));
  }, []);

  async function open(category: string, name: string) {
    setSel({ category, name });
    setLoading(true);
    setMsg('');
    try {
      const { item } = await api.getPipelineMd(category, name);
      setContent(item.content);
    } catch {
      setMsg('Falha ao abrir');
    } finally {
      setLoading(false);
    }
  }

  async function save() {
    if (!sel) return;
    setSaving(true);
    setMsg('');
    try {
      await api.savePipelineMd(sel.category, sel.name, content);
      setMsg('Salvo ✓ (vale na próxima execução, sem deploy)');
    } catch {
      setMsg('Falha ao salvar');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Page title="Roteiros & Fluxos (IA)">
      <p style={{ color: 'var(--muted)', marginTop: 0 }}>
        O comportamento das IAs do desenvolvimento (o que cada step faz, a sequência e as ênfases de cada fluxo, e os
        prompts dos outros fluxos). Editar aqui vale na hora, sem deploy.
      </p>
      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
        <div style={{ width: 260, flexShrink: 0 }}>
          {CATS.map((cat) => {
            const list = items.filter((i) => i.category === cat);
            if (list.length === 0) return null;
            return (
              <div key={cat} style={{ marginBottom: 12 }}>
                <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--muted)', margin: '8px 0 4px' }}>
                  {CAT_LABEL[cat] ?? cat}
                </div>
                {list.map((i) => {
                  const active = sel?.category === i.category && sel?.name === i.name;
                  return (
                    <button
                      key={i.name}
                      type="button"
                      onClick={() => open(i.category, i.name)}
                      style={{
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        padding: '6px 8px',
                        borderRadius: 6,
                        background: active ? 'var(--bg-soft, #eef)' : 'transparent',
                        border: '1px solid transparent',
                        cursor: 'pointer',
                        fontWeight: active ? 600 : 400,
                      }}
                    >
                      {i.name}
                    </button>
                  );
                })}
              </div>
            );
          })}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          {sel ? (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <strong>{sel.category}/{sel.name}.md</strong>
                <span>
                  {msg && <span style={{ marginRight: 8, color: 'var(--muted)', fontSize: 13 }}>{msg}</span>}
                  <button type="button" className="primary" disabled={saving || loading} onClick={save}>
                    {saving ? 'salvando…' : 'Salvar'}
                  </button>
                </span>
              </div>
              <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                disabled={loading}
                spellCheck={false}
                style={{ width: '100%', height: '62vh', fontFamily: 'monospace', fontSize: 13, lineHeight: 1.5 }}
              />
            </>
          ) : (
            <p style={{ color: 'var(--muted)' }}>Selecione um item à esquerda para ver/editar.</p>
          )}
        </div>
      </div>
    </Page>
  );
}
